import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpersService } from '../../../services/helpers.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit {
  public form: any = { email: '' };
  public busyResetting: boolean = false;
  public error: boolean = false;
  public errorMessage: string = '';

  constructor(
    public authenticationService: AuthenticationService,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {}

  reset() {
    this.busyResetting = true;
    this.authenticationService.resetPassword(this.form.email).subscribe(
      (result) => {
        this.busyResetting = false;
        if (!result.WasSuccessfull) {
          this.error = true;
          this.errorMessage = 'There was an error resetting your password.';
        } else {
          this.error = true;
          this.errorMessage = 'A link has been sent to your email.';
        }
      },
      (error) => {
        this.error = true;
        this.busyResetting = false;
        this.errorMessage = 'There was an error resetting your password.';
      },
    );
  }
}
